import { keyframes } from "styled-components";

export const scaleOut = (fromRate = 0.5, toRate = 1) => keyframes`
  from {
    transform: scale(${fromRate});
  }

  to {
    transform: scale(${toRate});
  }
`;

export const bounce = () => keyframes`
  0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
	40% {transform: translateY(-10px);}
	60% {transform: translateY(-5px);}
`;

export const fadeIn = () => keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const fadeOut = () => keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;
